import { bindable, customElement } from "aurelia-templating";

@customElement("report-footer-information")
export class ReportFooterInformation {
    @bindable
    public smallText: unknown;
    @bindable
    public name: string;
    @bindable
    public created: Date;
    @bindable
    public pageNumber: number;
    @bindable
    public maxPages: number;
}
